import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import HeroTransition from '../components/HeroTransition';
import About from '../components/About';
import Rooms from '../components/Rooms';
import FamilySpaces from '../components/FamilySpaces';
import Services from '../components/Services';
import Attractions from '../components/Attractions';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <HeroTransition />
      <About />
      <Rooms />
      <FamilySpaces />
      <Services />
      <Attractions />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Home;
